import axios from "axios";
import { API_BASE_URL } from "@/lib/apiBase";

/** In-flight / resolved GET /user/me keyed by access token (dedupe session callers). */
let cache = {
  token: null,
  data: null,
  promise: null,
};

export function invalidateUserMe() {
  cache = { token: null, data: null, promise: null };
}

/**
 * Shared GET /user/me — concurrent callers with the same token share one request.
 * @param {string} accessToken
 * @returns {Promise<object|null>}
 */
export async function fetchUserMe(accessToken) {
  if (!accessToken) return null;
  if (cache.token === accessToken && cache.data) {
    return cache.data;
  }
  if (cache.token === accessToken && cache.promise) {
    return cache.promise;
  }
  cache.token = accessToken;
  cache.data = null;
  cache.promise = axios
    .get(`${API_BASE_URL}/user/me`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then((res) => {
      cache.data = res.data;
      cache.promise = null;
      return cache.data;
    })
    .catch((err) => {
      if (cache.token === accessToken) {
        cache.promise = null;
        cache.token = null;
        cache.data = null;
      }
      throw err;
    });
  return cache.promise;
}

/** After PATCH /user/me (or similar), keep cache warm without another GET. */
export function seedUserMe(accessToken, data) {
  if (!accessToken || !data) return;
  cache = { token: accessToken, data, promise: null };
}
